import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../_metronic/helpers'
import useSWR from 'swr'
import { fetchWithToken } from '../../../api/General'
import useAccessToken from '../../../hooks/AccessToken'
import useUser from '../../../hooks/User'
import { User } from '../../../interfaces/User'
import { useFormik } from 'formik'
import { CustomField } from '../../../interfaces/Settings'
import { DataTableExportTemplate } from '../DataTableExportTemplate'
import { getCustomFieldError, getCustomFieldFilteredMeeting, validateLabel, validateMeetingParticipants } from '../../../functions/ExportTemplateExcel/functionHelperExcel'
import { useMeetingStore } from '../../../stores/MeetingsStore'
import { isEmail, isImageUrl } from '../../../functions/general'
import { usePipelineStore } from '../../../stores/PipelineStore'
import { useMerchantStore } from '../../../stores/MerchantStore'
import { FileUploader } from "react-drag-drop-files";
import { useGeneralStore } from '../../../stores/General'
import { useUserStore } from '../../../stores/UserStore'
import useHandleImportScheduleMeeting from '../HandleImport/meeting/useHandleImportScheduleMeeting'
import useHandleImportReportMeeting from '../HandleImport/meeting/useHandleImportReportMeeting'
import useHandleImportVisitMeeting from '../HandleImport/meeting/useHandleImportVisitMeeting'
import useHandleImportScheduleVisitMeeting from '../HandleImport/meeting/useHandleImportScheduleVisitMeeting'
import ModalSelectDataCustomField from '../ModalSelectDataCustomField'
import { Merchant } from '../../../interfaces/Merchant'
import { Dropdown } from 'rsuite'
import ButtonDropdownMeeting from '../../Meetings/ButtonDropdownMeeting'
import { Label } from '../../../interfaces/Label'
import moment from 'moment-timezone'
import Swal from 'sweetalert2'
import { validateDateTime } from '../../../functions/ExportTemplateExcel/helperTemplateExcel'
import ButtonImportDropdownMeeting from '../../Meetings/ButtonImportDropdownMeeting'
import { getUsers } from '../../../api/UsersCRUD'
import { UserCompany } from '../../../interfaces/UserCompany'
import { useSettingsStore } from '../../../stores/SettingsStore'
import { useProductStore } from '../../../stores/ProductStore'


interface DataTableImportMeetingProps {
    customFields: CustomField
    typeAction: 'insert' | 'update'
    typeMeeting: 'schedule' | 'visit' | 'report' | 'schedule-visit'
    codeUrl: string
    users: User[]
    usersCompany: UserCompany[]
    labels: Label[]
    setShowModalInsertImportExcel: (showModalInsertImportExcel: boolean) => void
}

const API_URL = process.env.REACT_APP_API_URL

const DataTableImportMeeting = ({ customFields, typeAction, typeMeeting, codeUrl, labels, setShowModalInsertImportExcel, users, usersCompany }: DataTableImportMeetingProps) => {
    const intl = useIntl()
    const token = useAccessToken()
    const user = useUser()
    const modalRef = useRef<HTMLDivElement | null>(null)
    const closeModalRef = useRef<HTMLButtonElement>(null)
    const [listErrorInsert, setListErrorInsert] = useState<string[]>([])
    const { simplePipelines } = usePipelineStore()
    const { simpleMerchants } = useMerchantStore()
    const { simpleMeetings, multiMeetings, setTypeMeeting, selectMultiMeeting } = useMeetingStore()
    const { simpleProducts } = useProductStore()
    const [indexUpload, setIndexUpload] = useState(0)
    const templateMeetingId = codeUrl
    const filteredCustomFieldMeeting = getCustomFieldFilteredMeeting(templateMeetingId, multiMeetings)
    const [listData, setListData] = useState<any>([])
    const { isOpenModalSelectCustomField, setIsOpenModalSelectCustomField, setIsCustomFieldPipeline, setIsCustomFieldMerchant, setIsCustomFieldUser, setIsCustomFieldMeeting } = useGeneralStore();
    const [dataUsers, setDataUsers] = useState<User[]>([])
    const { settings } = useSettingsStore()
    let dataError: any[] = []
    let dataSuccess: any[] = []

    const { handleChangeScheduleMeeting, handleInsertScheduleMeeting } = useHandleImportScheduleMeeting({ customFields, setListData, templateMeetingId: templateMeetingId, dataUsers: dataUsers, dataUsersCompany: usersCompany, dataSuccess, dataLabel: labels })
    const { handleChangeReportMeeting, handleInsertReportMeeting } = useHandleImportReportMeeting({ customFields, setListData, templateMeetingId: templateMeetingId, dataUsers: dataUsers, dataUsersCompany: usersCompany, dataSuccess, dataLabel: labels })
    const { handleChangeVisitMeeting, handleInsertVisitMeeting } = useHandleImportVisitMeeting({ customFields, setListData, templateMeetingId: templateMeetingId, dataUsers: dataUsers, dataUsersCompany: usersCompany, dataSuccess, dataLabel: labels })
    const { handleChangeScheduleVisitMeeting, handleInsertScheduleVisitMeeting } = useHandleImportScheduleVisitMeeting({ customFields, setListData, templateMeetingId: templateMeetingId, dataUsers: dataUsers, dataUsersCompany: usersCompany, dataSuccess, dataLabel: labels })

    const formik = useFormik({
        initialValues: {
            data: ''
        }, onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            for (var i = 0; i < listData.length; i++) {
                try {
                    setIndexUpload(i);
                    await handleCheckExcel(listData[i]);
                } catch (error: any) {
                    if (error.response.data) {
                        let mergeError = {
                            ...listData[i],
                            error: error.response.data.message,
                        };
                        dataError.push(mergeError);
                    } else {
                        let mergeError = { ...listData[i], error: error.message };
                        dataError.push(mergeError);
                    }
                }
            }

            if (typeAction === 'insert') setListErrorInsert(dataError)
            setListData([])
            setSubmitting(false);

            if (dataSuccess.length > 0) {
                Swal.fire({
                    icon: 'success',
                    title: intl.formatMessage({ id: 'ALERT.TITLE.SUCCESS' }),
                    html: `<b>${dataSuccess.length} Data</b> ${typeAction === 'insert'
                        ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_SUCCESS' })
                        : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_SUCCESS' })
                        }.
                        <br>
                        ${dataError.length > 0
                            ? `<b style="color: red;">${dataError.length} Data </b>${typeAction === 'insert'
                                ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_FAILED' })
                                : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_FAILED' })
                            }`
                            : ''
                        }
                        `,
                    heightAuto: false,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: intl.formatMessage({ id: 'ALERT.TITLE.ERROR' }),
                    html: `<b>${dataError.length} Data</b> ${typeAction === 'insert' ? intl.formatMessage({ id: 'FORM.VALIDATION.ADD_FAILED' }) : intl.formatMessage({ id: 'FORM.VALIDATION.UPDATE_FAILED' })}.`,
                    heightAuto: false,
                });
            }

            if (dataError.length === 0) {
                closeModalRef.current?.click();
            }
        }
    })

    const handleCheckExcel = async (data: any) => {
        const fieldsErrors: string[] = []
        if (typeAction === 'insert') {
            if (typeMeeting === 'schedule') {
                if (!data.ownerId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PIC' }) }));
                if (!data.merchantId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.MERCHANT' }) }));
                if (!data.dateTime) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.DATE' }, { title: selectMultiMeeting.name }) }));
                if (!data.longitude && !data.latitude && !data.locationName) {
                    fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.LOCATION_INVALID' }));
                }

                if (data.dateTime) {
                    const dateTimeErrors = validateDateTime(data.dateTime, intl);
                    if (dateTimeErrors.length > 0) {
                        fieldsErrors.push(...dateTimeErrors);
                    }
                }

                // Validasi Label dan Participant
                fieldsErrors.push(...validateLabel(data, labels, intl));
                fieldsErrors.push(...validateMeetingParticipants(data, usersCompany, intl));

                Object.keys(filteredCustomFieldMeeting).forEach((key) => {
                    getCustomFieldError(data, filteredCustomFieldMeeting, key, fieldsErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
                });
            } else if (typeMeeting === 'report') {
                if (!data.ownerId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PIC' }) }));
                if (!data.merchantId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.MERCHANT' }) }));
                if (!data.dateTime) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.DATE' }) }));
                if (!data.longitude && !data.latitude && !data.locationName) {
                    fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.LOCATION_INVALID' }));
                }
                if (!data.attachments) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.ATTACHMENT' }) }));
                if (data.attachments) {
                    if (!isImageUrl(data.attachments)) {
                        fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: intl.formatMessage({ id: 'FORM.LABEL.ATTACHMENT' }) }));
                    }
                }
                if (data.dateTime) {
                    const dateTimeErrors = validateDateTime(data.dateTime, intl, 'report');
                    if (dateTimeErrors.length > 0) {
                        fieldsErrors.push(...dateTimeErrors);
                    }
                }

                // Validasi Label dan Participant
                fieldsErrors.push(...validateLabel(data, labels, intl));
                fieldsErrors.push(...validateMeetingParticipants(data, usersCompany, intl));

                Object.keys(filteredCustomFieldMeeting).forEach((key) => {
                    getCustomFieldError(data, filteredCustomFieldMeeting, key, fieldsErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
                });
            } else if (typeMeeting === 'visit') {
                if (!data.ownerId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PIC' }) }));
                if (!data.merchantId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.MERCHANT' }) }));
                if (!data.longitude && !data.latitude && !data.locationName) {
                    fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.LOCATION_INVALID' }));
                }
                if (!data.attachments) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PHOTO' }, { title: selectMultiMeeting.name }) }));
                if (data.attachments) {
                    if (!isImageUrl(data.attachments)) {
                        fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.URL_CORRECTLY' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PHOTO' }, { title: selectMultiMeeting.name }) }));
                    }
                }

                // Validasi Label dan Participant
                fieldsErrors.push(...validateLabel(data, labels, intl));
                fieldsErrors.push(...validateMeetingParticipants(data, usersCompany, intl));

                Object.keys(filteredCustomFieldMeeting).forEach((key) => {
                    getCustomFieldError(data, filteredCustomFieldMeeting, key, fieldsErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
                });
            } else if (typeMeeting === 'schedule-visit') {
                if (!data.ownerId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.PIC' }) }));
                if (!data.merchantId) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.MERCHANT' }) }));
                if (!data.dateTime) fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.FIELD_REQUIRED' }, { title: intl.formatMessage({ id: 'FORM.LABEL.DATE' }) }));
                if (!data.longitude && !data.latitude && !data.locationName) {
                    fieldsErrors.push(intl.formatMessage({ id: 'FORM.VALIDATION.LOCATION_INVALID' }));
                }

                if (data.dateTime) {
                    const dateTimeErrors = validateDateTime(data.dateTime, intl);
                    if (dateTimeErrors.length > 0) {
                        fieldsErrors.push(...dateTimeErrors);
                    }
                }

                // Validasi Label dan Participant
                fieldsErrors.push(...validateLabel(data, labels, intl));
                fieldsErrors.push(...validateMeetingParticipants(data, usersCompany, intl));

                Object.keys(filteredCustomFieldMeeting).forEach((key) => {
                    getCustomFieldError(data, filteredCustomFieldMeeting, key, fieldsErrors, intl, simplePipelines, simpleMeetings, simpleMerchants, simpleProducts, users, user);
                });
            }
        }
        if (fieldsErrors.length === 0) {
            if (typeMeeting === 'schedule') {
                await handleInsertScheduleMeeting(data)
            } else if (typeMeeting === 'visit') {
                await handleInsertVisitMeeting(data)
            } else if (typeMeeting === 'report') {
                await handleInsertReportMeeting(data)
            } else if (typeMeeting === 'schedule-visit') {
                await handleInsertScheduleVisitMeeting(data)
            }
        } else {
            dataError.push({
                ...data,
                error: fieldsErrors.join(", ")
            });

            return fieldsErrors.join(", ")
        }
    }

    const getUserURL = () => {
        if (user.data.permission_pipeline_read === "ALL" && settings.is_superadmin_allowed_as_pic) {
            return `${API_URL}user/company`
        } else if (user.data.permission_pipeline_read === "ALL") {
            return `${API_URL}users`
        } else {
            return `${API_URL}user/subordinates`
        }
    }

    const getUser = async () => {
        try {
            const response = await getUsers(token, getUserURL())
            if (response.data.success) {
                var data = response.data.data

                if (user.data.permission_merchant_create !== 'ALL') {
                    data.unshift({ id: user.data.id, name: user.data.name })
                }

                data.sort((a: any, b: any) => a.name.localeCompare(b.name))
                if (
                    user.data.permission_merchant_create === 'ALL' ||
                    user.data.permission_merchant_create === 'TEAM'
                ) {
                    setDataUsers(data)
                } else {
                    setDataUsers(data.filter((item: any) => item.id === user.data.id))
                }
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok',
            })
        }
    }

    useEffect(() => {
        getUser()
    }, [templateMeetingId])

    useEffect(() => {
        return () => {

            setIsOpenModalSelectCustomField(false);
            setIsCustomFieldPipeline(false);
            setIsCustomFieldMerchant(false);
            setIsCustomFieldUser(false);
            setIsCustomFieldMeeting(false);
        };
    }, []);

    return (
        <>
            {/* Button trigger modal */}
            <ButtonImportDropdownMeeting source={"Meeting"} setTypeMeeting={setTypeMeeting} setShowModalInsertImportExcel={setShowModalInsertImportExcel} />
            {/* End: Button trigger modal */}

            <div className="modal fade" tabIndex={-1} id={`import-excel-template-meeting-modal`} ref={modalRef} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{intl.formatMessage({ id: 'FORM.LABEL.IMPORT_EXCEL' })}</h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        {/* {
                            getLoadingData() && (
                            )
                        } */}
                        <form onSubmit={formik.handleSubmit} noValidate>
                            <div className="modal-body" style={{ height: "300px" }}>
                                <DataTableExportTemplate closeModalRef={closeModalRef} source={'template-meeting'} typeAction={typeAction} user={user} param={{ dataUsers }} customFields={customFields} isOpenModalSelectCustomField={isOpenModalSelectCustomField} typeMeeting={typeMeeting} allUser={users} usersCompany={usersCompany} />

                                {
                                    listErrorInsert.length > 0 && typeAction === 'insert' &&
                                    <DataTableExportTemplate closeModalRef={closeModalRef} source={'template-meeting'} typeAction={typeAction} user={user} param={{ dataUsers, listErrorInsert }} type="error" customFields={customFields} isOpenModalSelectCustomField={isOpenModalSelectCustomField} typeMeeting={typeMeeting} allUser={users} usersCompany={usersCompany} />
                                }

                                <FileUploader
                                    fileOrFiles={listData.length === 0 ? null : listData}
                                    classes="h-50"
                                    handleChange={async (e: any) => {
                                        if (typeMeeting === 'schedule') {
                                            await handleChangeScheduleMeeting(e)
                                        } else if (typeMeeting === 'visit') {
                                            await handleChangeVisitMeeting(e)
                                        } else if (typeMeeting === 'report') {
                                            await handleChangeReportMeeting(e)
                                        } else if (typeMeeting === 'schedule-visit') {
                                            await handleChangeScheduleVisitMeeting(e)
                                        }
                                    }}
                                    name="file"
                                    types={["XLSX", "XLS", "CSV"]}
                                />

                                {
                                    listData.length > 0 &&
                                    <div style={{ padding: "10px" }}>{listData.length} {intl.formatMessage({ id: 'FORM.LABEL.DATA_UPLOAD' })}</div>
                                }
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-dismiss="modal"
                                    ref={closeModalRef}
                                >
                                    {intl.formatMessage({ id: 'FORM.ACTION.CANCEL' })}
                                </button>
                                <button type="submit" className={`btn btn-primary me-10 ${formik.isSubmitting ? "disabled" : ""}`} data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}>
                                    <span className="indicator-label">
                                        {intl.formatMessage({ id: 'FORM.ACTION.UPLOAD' })}
                                    </span>
                                    <span className="indicator-progress">
                                        Loading... &nbsp;
                                        {indexUpload + " / " + listData.length}
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {
                isOpenModalSelectCustomField && <ModalSelectDataCustomField customFields={customFields} source={'template-meeting'} typeAction={typeAction} param={{ dataUsers }} type={'success'} allUser={users} labels={labels} usersCompany={usersCompany} />
            }
        </>
    )
}

export default DataTableImportMeeting